import PropTypes from "prop-types";
import { useTranslation } from "react-i18next";

import { sectionTranslator } from "./readinessFormat";

const tr = sectionTranslator("empty");

// `noData`: the client has never answered it. `period`: they have, just not in this period.
export const ReadinessEmptyState = ({ kind, athleteName, trackingUrl }) => {
  const { t } = useTranslation("athlete-portal");

  if (kind === "period") {
    return (
      <div className="rr-empty">
        <p className="rr-empty__title">{tr(t, "periodTitle")}</p>
        <p className="rr-empty__text">{tr(t, "periodText")}</p>
      </div>
    );
  }

  return (
    <div className="rr-empty">
      <p className="rr-empty__title">{tr(t, "noDataTitle")}</p>
      <p className="rr-empty__text">
        {athleteName
          ? tr(t, "noDataCoach", { name: athleteName })
          : tr(t, "noDataSelf")}
      </p>
      {trackingUrl ? (
        // biome-ignore lint/a11y/useSemanticElements: anchor needed to navigate; role gives it the button style
        <a role="button" data-button-type="primary" href={trackingUrl}>
          {tr(t, "openTracking")}
        </a>
      ) : null}
    </div>
  );
};

ReadinessEmptyState.propTypes = {
  kind: PropTypes.oneOf(["noData", "period"]).isRequired,
  athleteName: PropTypes.string,
  trackingUrl: PropTypes.string,
};
